"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cssinjs = require("@ant-design/cssinjs");
var _motion = require("../../style/motion/motion");
var floatButtonGroupMotion = function floatButtonGroupMotion(token) {
  var componentCls = token.componentCls,
    floatButtonSize = token.floatButtonSize,
    motionDurationSlow = token.motionDurationSlow,
    motionEaseInOutCirc = token.motionEaseInOutCirc,
    calc = token.calc;
  var moveTopIn = new _cssinjs.Keyframes('antFloatButtonMoveTopIn', {
    '0%': {
      transform: "translate3d(0, ".concat((0, _cssinjs.unit)(floatButtonSize), ", 0)"),
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  var moveTopOut = new _cssinjs.Keyframes('antFloatButtonMoveTopOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: "translate3d(0, ".concat((0, _cssinjs.unit)(floatButtonSize), ", 0)"),
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  var moveRightIn = new _cssinjs.Keyframes('antFloatButtonMoveRightIn', {
    '0%': {
      transform: "translate3d(".concat(calc(floatButtonSize).mul(-1).equal(), ", 0, 0)"),
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  var moveRightOut = new _cssinjs.Keyframes('antFloatButtonMoveRightOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: "translate3d(".concat(calc(floatButtonSize).mul(-1).equal(), ", 0, 0)"),
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  var moveBottomIn = new _cssinjs.Keyframes('antFloatButtonMoveBottomIn', {
    '0%': {
      transform: "translate3d(0, ".concat(calc(floatButtonSize).mul(-1).equal(), ", 0)"),
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  var moveBottomOut = new _cssinjs.Keyframes('antFloatButtonMoveBottomOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: "translate3d(0, ".concat(calc(floatButtonSize).mul(-1).equal(), ", 0)"),
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  var moveLeftIn = new _cssinjs.Keyframes('antFloatButtonMoveLeftIn', {
    '0%': {
      transform: "translate3d(".concat((0, _cssinjs.unit)(floatButtonSize), ", 0, 0)"),
      transformOrigin: '0 0',
      opacity: 0
    },
    '100%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    }
  });
  var moveLeftOut = new _cssinjs.Keyframes('antFloatButtonMoveLeftOut', {
    '0%': {
      transform: 'translate3d(0, 0, 0)',
      transformOrigin: '0 0',
      opacity: 1
    },
    '100%': {
      transform: "translate3d(".concat((0, _cssinjs.unit)(floatButtonSize), ", 0, 0)"),
      transformOrigin: '0 0',
      opacity: 0
    }
  });
  var groupPrefixCls = "".concat(componentCls, "-group");
  return [_defineProperty({}, groupPrefixCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&".concat(groupPrefixCls, "-top ").concat(groupPrefixCls, "-wrap"), (0, _motion.initMotion)("".concat(groupPrefixCls, "-wrap"), moveTopIn, moveTopOut, motionDurationSlow, true)), "&".concat(groupPrefixCls, "-bottom ").concat(groupPrefixCls, "-wrap"), (0, _motion.initMotion)("".concat(groupPrefixCls, "-wrap"), moveBottomIn, moveBottomOut, motionDurationSlow, true)), "&".concat(groupPrefixCls, "-left ").concat(groupPrefixCls, "-wrap"), (0, _motion.initMotion)("".concat(groupPrefixCls, "-wrap"), moveLeftIn, moveLeftOut, motionDurationSlow, true)), "&".concat(groupPrefixCls, "-right ").concat(groupPrefixCls, "-wrap"), (0, _motion.initMotion)("".concat(groupPrefixCls, "-wrap"), moveRightIn, moveRightOut, motionDurationSlow, true))), _defineProperty({}, "".concat(groupPrefixCls, "-wrap"), _defineProperty(_defineProperty({}, "&".concat(groupPrefixCls, "-wrap-enter, &").concat(groupPrefixCls, "-wrap-appear"), {
    opacity: 0,
    animationTimingFunction: motionEaseInOutCirc
  }), "&".concat(groupPrefixCls, "-wrap-leave"), {
    opacity: 1,
    animationTimingFunction: motionEaseInOutCirc
  }))];
};
var _default = exports["default"] = floatButtonGroupMotion;